// SBIS Consulting — Pregled konta (pretraga knjiženja po kontima)
import { state } from './state.js';
import { sb } from './supabase.js';
import { fNum, pDate } from './utils.js';
import { toast, showLoading, hideLoading } from './ui.js';
import { bindDatePicker, formatDateForInput } from './datepicker.js';
import XLSX from 'xlsx-js-style';

let lastResults = [];
let selectedAnalytics = null;
let allAnalyticOptions = [];
let analDropOpen = false;
let allKontaOptions = []; // from kontni_plan
let selectedKonta = new Set();
let kontoDropOpen = false;

export function initKontoSearch() {
  const toEl = document.getElementById('kontoTo');
  if (toEl && !toEl.value) toEl.value = formatDateForInput(new Date());
  bindDatePicker(document.getElementById('kontoFrom'));
  bindDatePicker(toEl);
  loadKontaOptions();
  document.addEventListener('mousedown', e => {
    const aw = document.getElementById('kontoAnalWrap');
    if (analDropOpen && aw && !aw.contains(e.target)) { document.getElementById('kontoAnalDrop').style.display = 'none'; analDropOpen = false; }
    const kw = document.getElementById('kontoSelWrap');
    if (kontoDropOpen && kw && !kw.contains(e.target)) { document.getElementById('kontoSelDrop').style.display = 'none'; kontoDropOpen = false; }
  });
}

async function loadKontaOptions() {
  const { data } = await sb.from('kontni_plan').select('rs_konto, en_name').is('deleted_at', null).order('rs_konto');
  allKontaOptions = (data || []).filter(k => k.rs_konto && !k.rs_konto.includes(','));
  renderKontoDropdown();
}

function renderKontoDropdown() {
  const list = document.getElementById('kontoSelList');
  if (!list) return;
  list.textContent = '';
  const q = (document.getElementById('kontoSelSearch')?.value || '').toLowerCase();
  const filtered = q ? allKontaOptions.filter(k => k.rs_konto.includes(q) || (k.en_name || '').toLowerCase().includes(q)) : allKontaOptions;

  // Selektuj sve / Očisti sve
  const actRow = document.createElement('div');
  actRow.style.cssText = 'display:flex;gap:8px;padding:8px 14px;border-bottom:1px solid var(--border)';
  const btnAll = document.createElement('button'); btnAll.className = 'bsm'; btnAll.style.cssText = 'font-size:10px;padding:3px 10px';
  btnAll.textContent = 'Selektuj sve'; btnAll.onclick = e => { e.stopPropagation(); filtered.forEach(k => selectedKonta.add(k.rs_konto)); updateKontoLabel(); renderKontoDropdown(); };
  const btnNone = document.createElement('button'); btnNone.className = 'bsm'; btnNone.style.cssText = 'font-size:10px;padding:3px 10px';
  btnNone.textContent = 'Očisti sve'; btnNone.onclick = e => { e.stopPropagation(); selectedKonta.clear(); updateKontoLabel(); renderKontoDropdown(); };
  actRow.appendChild(btnAll); actRow.appendChild(btnNone);
  list.appendChild(actRow);

  filtered.forEach(k => {
    const isChecked = selectedKonta.has(k.rs_konto);
    const row = document.createElement('div'); row.style.cssText = 'display:flex;align-items:center;gap:10px;padding:10px 14px;cursor:pointer;border-bottom:1px solid var(--border-lt);font-size:13px;transition:background .15s' + (isChecked ? ';background:rgba(201,168,76,.08)' : '');
    row.onmouseenter = () => { if (!selectedKonta.has(k.rs_konto)) row.style.background = 'var(--hover)'; };
    row.onmouseleave = () => { row.style.background = selectedKonta.has(k.rs_konto) ? 'rgba(201,168,76,.08)' : ''; };
    const cb = document.createElement('input'); cb.type = 'checkbox'; cb.checked = isChecked; cb.style.cssText = 'flex-shrink:0;pointer-events:none';
    const codeS = document.createElement('span'); codeS.style.cssText = 'font-family:var(--mn);font-weight:600;color:var(--acc);min-width:55px'; codeS.textContent = k.rs_konto;
    const nameS = document.createElement('span'); nameS.style.color = 'var(--tx)'; nameS.textContent = k.en_name || '';
    row.appendChild(cb); row.appendChild(codeS); row.appendChild(nameS);
    row.onclick = e => {
      e.stopPropagation();
      if (selectedKonta.has(k.rs_konto)) selectedKonta.delete(k.rs_konto); else selectedKonta.add(k.rs_konto);
      cb.checked = selectedKonta.has(k.rs_konto);
      row.style.background = cb.checked ? 'rgba(201,168,76,.08)' : '';
      updateKontoLabel();
    };
    list.appendChild(row);
  });
}

function updateKontoLabel() {
  const label = document.getElementById('kontoSelLabel');
  if (!selectedKonta.size) label.textContent = 'Izaberite konta...';
  else if (selectedKonta.size <= 3) label.textContent = [...selectedKonta].join(', ');
  else label.textContent = selectedKonta.size + ' konta izabrano';
}

export function toggleKontoDropdown() {
  const drop = document.getElementById('kontoSelDrop');
  kontoDropOpen = !kontoDropOpen;
  drop.style.display = kontoDropOpen ? 'block' : 'none';
  if (kontoDropOpen) {
    drop.onclick = e => e.stopPropagation();
    const s = document.getElementById('kontoSelSearch'); if (s) { s.value = ''; s.focus(); }
    renderKontoDropdown();
  }
}

export function filterKontoDropdown() { renderKontoDropdown(); }

export function clearKontoFilters() {
  selectedKonta.clear();
  updateKontoLabel();
  selectedAnalytics = null;
  allAnalyticOptions = [];
  lastResults = [];
  const analLabel = document.getElementById('kontoAnalLabel'); if (analLabel) analLabel.textContent = 'Prvo pretražite konto';
  const analDrop = document.getElementById('kontoAnalDrop'); if (analDrop) analDrop.textContent = '';
  const output = document.getElementById('kontoOutput'); if (output) output.textContent = '';
  const expBtn = document.getElementById('kontoExpBtn'); if (expBtn) expBtn.style.display = 'none';
  renderKontoDropdown();
  toast('Filteri očišćeni');
}

export function toggleAnalDropdown() {
  if (!allAnalyticOptions.length) { toast('Prvo kliknite "Pretraži" da se učitaju analitike', 'err'); return; }
  const drop = document.getElementById('kontoAnalDrop');
  analDropOpen = !analDropOpen;
  drop.style.display = analDropOpen ? 'block' : 'none';
  if (analDropOpen) drop.onclick = e => e.stopPropagation();
}

function populateAnalDropdown(data) {
  const analytics = {};
  data.filter(e => e.detail_level === 'ANALYTIC').forEach(e => {
    const ac = e.analytic_code || '?';
    if (!analytics[ac]) analytics[ac] = { code: ac, name: e.analytic_name || '' };
  });
  allAnalyticOptions = Object.values(analytics).sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true }));
  selectedAnalytics = null;

  const label = document.getElementById('kontoAnalLabel');
  if (!allAnalyticOptions.length) { label.textContent = 'Nema analitika'; return; }
  label.textContent = 'Sve analitike (' + allAnalyticOptions.length + ')';
  renderAnalList();
}

function renderAnalList() {
  const drop = document.getElementById('kontoAnalDrop');
  drop.textContent = '';

  // Search field
  const search = document.createElement('input'); search.type = 'text'; search.className = 'fi';
  search.style.cssText = 'width:100%;border:none;border-bottom:1px solid var(--border);border-radius:0;font-size:13px;padding:12px 16px';
  search.placeholder = 'Pretraži analitiku...'; search.id = 'analSearchInput';
  search.oninput = () => renderAnalList();
  search.onclick = e => e.stopPropagation();
  drop.appendChild(search);

  // Sve / Ništa buttons
  const actBar = document.createElement('div'); actBar.style.cssText = 'padding:8px 12px;border-bottom:1px solid var(--border);display:flex;gap:8px';
  const btnAll = document.createElement('button'); btnAll.className = 'bsm'; btnAll.style.cssText = 'font-size:12px;padding:4px 10px'; btnAll.textContent = 'Sve';
  btnAll.onclick = e => { e.stopPropagation(); selectedAnalytics = null; renderAnalList(); applyAnalFilter(); updateAnalLabel(); };
  const btnNone = document.createElement('button'); btnNone.className = 'bsm'; btnNone.style.cssText = 'font-size:12px;padding:4px 10px'; btnNone.textContent = 'Ništa';
  btnNone.onclick = e => { e.stopPropagation(); selectedAnalytics = new Set(); renderAnalList(); applyAnalFilter(); updateAnalLabel(); };
  actBar.appendChild(btnAll); actBar.appendChild(btnNone); drop.appendChild(actBar);

  // Filtered list
  const q = (document.getElementById('analSearchInput')?.value || '').toLowerCase();
  const list = document.createElement('div'); list.style.cssText = 'max-height:300px;overflow-y:auto';
  const filtered = q ? allAnalyticOptions.filter(a => a.code.includes(q) || a.name.toLowerCase().includes(q)) : allAnalyticOptions;

  filtered.forEach(a => {
    const isChecked = !selectedAnalytics || selectedAnalytics.has(a.code);
    const row = document.createElement('div'); row.style.cssText = 'display:flex;align-items:center;gap:10px;padding:10px 14px;cursor:pointer;border-bottom:1px solid var(--border-lt);font-size:13px;transition:background .15s' + (isChecked ? ';background:rgba(201,168,76,.08)' : '');
    row.onmouseenter = () => { if (!(selectedAnalytics ? selectedAnalytics.has(a.code) : true)) row.style.background = 'var(--hover)'; };
    row.onmouseleave = () => { row.style.background = (selectedAnalytics ? selectedAnalytics.has(a.code) : true) ? 'rgba(201,168,76,.08)' : ''; };
    const cb = document.createElement('input'); cb.type = 'checkbox'; cb.checked = isChecked;
    cb.style.cssText = 'flex-shrink:0;pointer-events:none';
    row.onclick = e => {
      e.stopPropagation();
      if (!selectedAnalytics) selectedAnalytics = new Set(allAnalyticOptions.map(x => x.code));
      const nowChecked = !selectedAnalytics.has(a.code);
      if (nowChecked) selectedAnalytics.add(a.code); else selectedAnalytics.delete(a.code);
      cb.checked = nowChecked;
      row.style.background = nowChecked ? 'rgba(201,168,76,.08)' : '';
      if (selectedAnalytics.size === allAnalyticOptions.length) selectedAnalytics = null;
      updateAnalLabel();
      applyAnalFilter();
    };
    const codeS = document.createElement('span'); codeS.style.cssText = 'font-family:var(--mn);font-weight:600;color:var(--tx3);min-width:50px'; codeS.textContent = a.code;
    const nameS = document.createElement('span'); nameS.style.color = 'var(--acc)'; nameS.textContent = a.name;
    row.appendChild(cb); row.appendChild(codeS); row.appendChild(nameS);
    list.appendChild(row);
  });
  drop.appendChild(list);

  // Restore search text after re-render
  const si = document.getElementById('analSearchInput');
  if (si && q) { si.value = q; si.setSelectionRange(q.length, q.length); si.focus(); }
}

function updateAnalCheckboxes() {
  document.querySelectorAll('#kontoAnalDrop input[type=checkbox]').forEach(cb => {
    cb.checked = !selectedAnalytics || selectedAnalytics.has(cb.dataset.code);
  });
  updateAnalLabel();
}

function updateAnalLabel() {
  const label = document.getElementById('kontoAnalLabel');
  if (!selectedAnalytics) label.textContent = 'Sve analitike (' + allAnalyticOptions.length + ')';
  else if (selectedAnalytics.size === 0) label.textContent = 'Ništa izabrano';
  else label.textContent = selectedAnalytics.size + ' od ' + allAnalyticOptions.length + ' analitika';
}

function applyAnalFilter() {
  let filtered = lastResults;
  if (selectedAnalytics && selectedAnalytics.size < allAnalyticOptions.length) {
    filtered = lastResults.filter(e => {
      if (e.detail_level === 'ANALYTIC') return selectedAnalytics.has(e.analytic_code || '?');
      return true;
    });
    const parentCodes = new Set(filtered.filter(e => e.detail_level === 'ANALYTIC').map(e => e.rs_code));
    filtered = filtered.filter(e => e.detail_level === 'ANALYTIC' || parentCodes.has(e.rs_code));
  }
  renderResults(filtered, [...selectedKonta].join(', '));
}

export async function searchKonto() {
  if (!selectedKonta.size) { toast('Izaberite bar jedan konto', 'err'); return; }
  if (!state.CU) return;

  const fromVal = document.getElementById('kontoFrom').value;
  const toVal = document.getElementById('kontoTo').value;
  const fromDate = pDate(fromVal);
  const toDate = pDate(toVal);
  if (fromDate && toDate && fromDate > toDate) { toast('Period od ne može biti posle perioda do', 'err'); return; }
  const pFrom = fromDate ? fromDate.toISOString().slice(0, 10) : null;
  // Dodaj 1 dan na "Do" da bi uključio i taj dan (RPC koristi < umesto <=)
  let pTo = null;
  if (toDate) { const next = new Date(toDate); next.setDate(next.getDate() + 1); pTo = next.toISOString().slice(0, 10); }

  const queries = [...selectedKonta];
  const rawQuery = queries.join(', ');

  showLoading();
  try {
    // Direktan query na knjizenja_entries — pouzdanije od search_konto RPC
    let query = sb.from('knjizenja_entries')
      .select('id,rs_code,rs_name,en_name,debit,credit,detail_level,analytic_code,analytic_name,booking_date,source_file')
      .eq('user_id', state.CU.id).eq('is_final', true);
    if (pFrom) query = query.gte('period_from', pFrom);
    if (pTo) query = query.lte('period_from', pTo);
    // Fetch all (paginate if >1000)
    let allData = [], offset = 0;
    while (true) {
      const { data, error } = await query.range(offset, offset + 999);
      if (error) throw error;
      if (!data || !data.length) break;
      allData.push(...data);
      if (data.length < 1000) break;
      offset += 1000;
    }
    // Filter by selected konta
    if (queries.length < allKontaOptions.length) {
      const selSet = new Set(queries);
      allData = allData.filter(e => selSet.has(e.rs_code));
    }
    lastResults = allData;
    populateAnalDropdown(allData);
    renderResults(allData, rawQuery);
    document.getElementById('kontoExpBtn').style.display = allData.length ? '' : 'none';
  } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
  hideLoading();
}

function renderResults(data, query) {
  const out = document.getElementById('kontoOutput');
  out.textContent = '';

  if (!data.length) {
    const p = document.createElement('div'); p.className = 'card';
    p.style.cssText = 'padding:40px;text-align:center;color:var(--tx3);font-size:13px';
    p.textContent = 'Nema rezultata za "' + query + '"';
    out.appendChild(p); return;
  }

  // Group by rs_code — totali iz PARENT/SUMMARY (ANALYTIC se ne broji jer je već u PARENT)
  const byKonto = {};
  data.forEach(e => {
    const key = e.rs_code;
    if (!byKonto[key]) byKonto[key] = { rs_code: e.rs_code, en_name: e.en_name, entries: [], totalD: 0, totalC: 0 };
    byKonto[key].entries.push(e);
    if (e.detail_level !== 'ANALYTIC') {
      byKonto[key].totalD += parseFloat(e.debit || 0);
      byKonto[key].totalC += parseFloat(e.credit || 0);
    }
  });
  // Leksikografsko sortiranje konta (001, 011, 0118, 012, 01280, ...)
  const kontoList = Object.values(byKonto).sort((a, b) => a.rs_code.localeCompare(b.rs_code));

  // Summary cards
  const sumBar = document.createElement('div'); sumBar.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:14px;margin-bottom:20px';
  // Grand total: PARENT+SUMMARY samo (ANALYTIC je već uračunat u PARENT) — kao Istorija
  const nonAnalytic = data.filter(e => e.detail_level !== 'ANALYTIC');
  const grandD = nonAnalytic.reduce((s, e) => s + (parseFloat(e.debit) || 0), 0);
  const grandC = nonAnalytic.reduce((s, e) => s + (parseFloat(e.credit) || 0), 0);
  const totalEntries = nonAnalytic.length;

  [{ l: 'Rezultata', v: kontoList.length + ' konta', c: 'var(--acc)' },
   { l: 'Stavki', v: totalEntries, c: 'var(--tx)' },
   { l: 'Ukupno Duguje', v: fNum(grandD) + ' RSD', c: 'var(--dng)' },
   { l: 'Ukupno Potražuje', v: fNum(grandC) + ' RSD', c: 'var(--suc)' },
   { l: 'Saldo', v: fNum(grandD - grandC) + ' RSD', c: grandD > grandC ? 'var(--dng)' : 'var(--suc)' }
  ].forEach(s => {
    const card = document.createElement('div'); card.className = 'card';
    card.style.cssText = 'padding:18px 22px;display:flex;flex-direction:column;gap:4px';
    const lbl = document.createElement('div'); lbl.style.cssText = 'font-size:13px;color:var(--tx3);text-transform:uppercase;letter-spacing:.5px'; lbl.textContent = s.l;
    const val = document.createElement('div'); val.style.cssText = 'font-size:14px;font-weight:700;font-family:var(--mn);color:' + s.c; val.textContent = s.v;
    card.appendChild(lbl); card.appendChild(val); sumBar.appendChild(card);
  });
  out.appendChild(sumBar);

  // Sticky zaglavlje kolona
  const stickyHdr = document.createElement('table'); stickyHdr.style.cssText = 'width:100%;border-collapse:collapse;position:sticky;top:0;z-index:10;background:var(--base);margin-bottom:8px;border-bottom:2px solid var(--acc)';
  const shtr = document.createElement('tr');
  [{ h: 'KONTO', w: '8%', a: 'left' }, { h: 'NAZIV', w: '', a: 'left' }, { h: 'DUGUJE', w: '14%', a: 'right' }, { h: 'POTRAŽUJE', w: '14%', a: 'right' }, { h: 'SALDO', w: '12%', a: 'right' }, { h: '', w: '20%', a: 'left' }, { h: '', w: '8%', a: 'left' }].forEach(col => {
    const th = document.createElement('th'); th.textContent = col.h;
    th.style.cssText = 'padding:12px 14px;font-size:12px;color:var(--tx3);text-transform:uppercase;letter-spacing:.5px;font-weight:600;text-align:' + col.a;
    if (col.w) th.style.width = col.w;
    shtr.appendChild(th);
  });
  stickyHdr.appendChild(shtr); out.appendChild(stickyHdr);

  // Per-konto expandable sections, sa KLASA subtotalima
  let currentClass = null;
  let classD = 0, classC = 0;

  function renderClassTotal(cls) {
    if (cls === null) return;
    const saldo = classD - classC;
    const bar = document.createElement('table'); bar.style.cssText = 'width:100%;border-collapse:collapse;margin-bottom:16px;background:linear-gradient(90deg,rgba(201,168,76,.18),rgba(201,168,76,.06));border:1px solid var(--acc);border-radius:8px;overflow:hidden';
    const tr = document.createElement('tr');
    const td1 = document.createElement('td'); td1.style.cssText = 'padding:14px;font-size:15px;font-weight:700;color:var(--acc);width:8%'; td1.textContent = '';
    const td2 = document.createElement('td'); td2.style.cssText = 'padding:14px;font-size:15px;font-weight:700;color:var(--acc)'; td2.textContent = 'KLASA ' + cls;
    const td3 = document.createElement('td'); td3.style.cssText = 'padding:14px;text-align:right;font-family:var(--mn);font-size:14px;font-weight:700;color:var(--dng);width:14%'; td3.textContent = fNum(classD);
    const td4 = document.createElement('td'); td4.style.cssText = 'padding:14px;text-align:right;font-family:var(--mn);font-size:14px;font-weight:700;color:var(--suc);width:14%'; td4.textContent = fNum(classC);
    const td5 = document.createElement('td'); td5.style.cssText = 'padding:14px;text-align:right;font-family:var(--mn);font-size:14px;font-weight:700;width:12%;color:' + (saldo > 0 ? 'var(--dng)' : 'var(--suc)'); td5.textContent = fNum(saldo);
    const td6 = document.createElement('td'); td6.style.cssText = 'padding:14px;width:20%';
    const td7 = document.createElement('td'); td7.style.cssText = 'padding:14px;width:8%';
    tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5); tr.appendChild(td6); tr.appendChild(td7);
    bar.appendChild(tr); out.appendChild(bar);
  }

  kontoList.forEach((k, idx) => {
    const kClass = k.rs_code.charAt(0);
    if (kClass !== currentClass) {
      // Zatvori prethodnu klasu
      renderClassTotal(currentClass);
      currentClass = kClass;
      classD = 0; classC = 0;
    }
    classD += k.totalD; classC += k.totalC;
    const card = document.createElement('div'); card.className = 'card'; card.style.cssText = 'padding:0;margin-bottom:12px;overflow:hidden';

    const saldo = k.totalD - k.totalC;

    // Header as table row matching column layout
    const analyticsEntries = k.entries.filter(e => e.detail_level === 'ANALYTIC');
    const uniqueAnalytics = new Set(analyticsEntries.map(e => e.analytic_code)).size;

    const hdr = document.createElement('table'); hdr.style.cssText = 'width:100%;border-collapse:collapse;cursor:pointer;background:var(--surface);transition:background .2s';
    hdr.onmouseenter = () => hdr.style.background = 'var(--hover)'; hdr.onmouseleave = () => hdr.style.background = 'var(--surface)';
    const htr2 = document.createElement('tr');
    const htd1 = document.createElement('td'); htd1.style.cssText = 'padding:16px 14px;font-size:14px;width:8%';
    const codeS = document.createElement('span'); codeS.style.cssText = 'font-family:var(--mn);font-weight:700;color:var(--acc)'; codeS.textContent = k.rs_code;
    htd1.appendChild(codeS);
    const htd2 = document.createElement('td'); htd2.style.cssText = 'padding:16px 14px;font-size:13px;color:var(--tx)';
    htd2.textContent = (k.en_name || '') + '  ';
    const countS = document.createElement('span'); countS.style.cssText = 'font-size:13px;color:var(--tx3)'; countS.textContent = uniqueAnalytics + ' analitika';
    htd2.appendChild(countS);
    const htd3 = document.createElement('td'); htd3.style.cssText = 'padding:16px 14px;text-align:right;font-family:var(--mn);font-size:13px;font-weight:600;color:var(--dng);width:14%'; htd3.textContent = fNum(k.totalD);
    const htd4 = document.createElement('td'); htd4.style.cssText = 'padding:16px 14px;text-align:right;font-family:var(--mn);font-size:13px;font-weight:600;color:var(--suc);width:14%'; htd4.textContent = fNum(k.totalC);
    const htd5 = document.createElement('td'); htd5.style.cssText = 'padding:16px 14px;text-align:right;font-family:var(--mn);font-size:13px;font-weight:700;width:12%;color:' + (saldo > 0 ? 'var(--dng)' : 'var(--suc)'); htd5.textContent = fNum(saldo);
    const chev = document.createElement('span'); chev.style.cssText = 'margin-left:10px;color:var(--tx3);font-size:14px;transition:transform .2s;display:inline-block'; chev.textContent = '\u25BC';
    htd5.appendChild(chev);
    const htd6 = document.createElement('td'); htd6.style.cssText = 'padding:16px 14px;width:20%';
    const htd7 = document.createElement('td'); htd7.style.cssText = 'padding:16px 14px;width:8%';
    htr2.appendChild(htd1); htr2.appendChild(htd2); htr2.appendChild(htd3); htr2.appendChild(htd4); htr2.appendChild(htd5); htr2.appendChild(htd6); htr2.appendChild(htd7);
    hdr.appendChild(htr2);

    // Body
    const body = document.createElement('div'); body.style.display = 'none';
    hdr.onclick = () => { const open = body.style.display !== 'none'; body.style.display = open ? 'none' : 'block'; chev.style.transform = open ? '' : 'rotate(180deg)'; };

    // Group analytics by analytic_code — sum duguje/potrazuje per unique analytic
    const byAnalytic = {};
    analyticsEntries.forEach(e => {
      const ac = e.analytic_code || '?';
      if (!byAnalytic[ac]) byAnalytic[ac] = { code: ac, name: e.analytic_name || '', duguje: 0, potrazuje: 0 };
      byAnalytic[ac].duguje += parseFloat(e.debit || 0);
      byAnalytic[ac].potrazuje += parseFloat(e.credit || 0);
    });
    const analyticList = Object.values(byAnalytic).sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true }));

    const tbl = document.createElement('table'); tbl.style.cssText = 'width:100%;font-size:13px;border-collapse:collapse';
    const thead = document.createElement('thead'); const htr = document.createElement('tr');
    [{ h: 'Analitika', w: '8%' }, { h: 'Naziv', w: '' }, { h: 'Duguje', w: '14%' }, { h: 'Potražuje', w: '14%' }, { h: 'Saldo', w: '12%' }, { h: 'Dokument', w: '20%' }, { h: 'Datum', w: '8%' }].forEach(col => {
      const th = document.createElement('th'); th.textContent = col.h;
      th.style.cssText = 'text-align:left;padding:12px 14px;border-bottom:2px solid var(--border);color:var(--tx3);font-size:13px;text-transform:uppercase;letter-spacing:.5px;position:sticky;top:0;background:var(--raised)';
      if (col.w) th.style.width = col.w;
      if (['Duguje', 'Potražuje', 'Saldo'].includes(col.h)) th.style.textAlign = 'right';
      htr.appendChild(th);
    });
    thead.appendChild(htr); tbl.appendChild(thead);
    const tbody = document.createElement('tbody');

    // If no analytics, show parent entries instead
    if (!analyticList.length) {
      k.entries.filter(e => e.detail_level !== 'ANALYTIC').forEach(e => {
        const d = parseFloat(e.debit || 0), c = parseFloat(e.credit || 0), s = d - c;
        const doc = (e.source_file || '').replace(/FINANSIJSKO KNJIZENJE /g, '').replace(/_Privredno.*/, '');
        const tr = document.createElement('tr'); tr.style.borderBottom = '1px solid var(--border-lt)';
        const td1 = document.createElement('td'); td1.style.cssText = 'padding:10px 14px;font-family:var(--mn);font-weight:600;color:var(--acc);font-size:13px'; td1.textContent = e.rs_code;
        const td2 = document.createElement('td'); td2.style.cssText = 'padding:10px 14px;color:var(--tx);font-size:13px'; td2.textContent = e.en_name || e.rs_name || '';
        const td3 = document.createElement('td'); td3.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:13px'; if (d > 0) { td3.textContent = fNum(d); td3.style.color = 'var(--dng)'; }
        const td4 = document.createElement('td'); td4.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:13px'; if (c > 0) { td4.textContent = fNum(c); td4.style.color = 'var(--suc)'; }
        const td5 = document.createElement('td'); td5.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:13px;font-weight:600;color:' + (s >= 0 ? 'var(--dng)' : 'var(--suc)'); td5.textContent = fNum(s);
        const td6 = document.createElement('td'); td6.style.cssText = 'padding:10px 14px;font-size:11px;color:var(--tx3)'; td6.textContent = doc;
        const td7 = document.createElement('td'); td7.style.cssText = 'padding:10px 14px;font-size:11px;color:var(--tx3)'; td7.textContent = e.booking_date || '';
        tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5); tr.appendChild(td6); tr.appendChild(td7);
        tbody.appendChild(tr);
      });
    } else {
      analyticList.forEach(a => {
        const s = a.duguje - a.potrazuje;
        // Individual entries for this analytic
        const aEntries = analyticsEntries.filter(e => (e.analytic_code || '?') === a.code);

        const tr = document.createElement('tr'); tr.style.cssText = 'border-bottom:1px solid var(--border-lt);cursor:pointer;transition:background .15s';
        tr.onmouseenter = () => tr.style.background = 'var(--hover)'; tr.onmouseleave = () => tr.style.background = '';
        const td1 = document.createElement('td'); td1.style.cssText = 'padding:10px 14px;font-family:var(--mn);font-weight:600;color:var(--tx3);font-size:13px';
        const chevA = document.createElement('span'); chevA.style.cssText = 'font-size:12px;margin-right:8px;display:inline-block;transition:transform .2s;color:var(--tx3)'; chevA.textContent = '\u25B6';
        td1.appendChild(chevA); td1.appendChild(document.createTextNode(a.code));
        const td2 = document.createElement('td'); td2.style.cssText = 'padding:10px 14px;color:var(--acc);font-size:13px'; td2.textContent = a.name;
        const countBadge = document.createElement('span'); countBadge.style.cssText = 'margin-left:8px;font-size:14px;color:var(--tx3)'; countBadge.textContent = '(' + aEntries.length + ')';
        td2.appendChild(countBadge);
        const td3 = document.createElement('td'); td3.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:13px'; if (a.duguje > 0) { td3.textContent = fNum(a.duguje); td3.style.color = 'var(--dng)'; }
        const td4 = document.createElement('td'); td4.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:13px'; if (a.potrazuje > 0) { td4.textContent = fNum(a.potrazuje); td4.style.color = 'var(--suc)'; }
        const td5 = document.createElement('td'); td5.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:13px;font-weight:600;color:' + (s >= 0 ? 'var(--dng)' : 'var(--suc)'); td5.textContent = fNum(s);
        // Populate doc/date: show all docs for this analytic
        const aDocNames = [...new Set(aEntries.map(e => (e.source_file || '').replace(/FINANSIJSKO KNJIZENJE /g, '').replace(/_Privredno.*/, '')).filter(Boolean))];
        const aDates = [...new Set(aEntries.map(e => e.booking_date || '').filter(Boolean))];
        const td6 = document.createElement('td'); td6.style.cssText = 'padding:10px 14px;font-size:11px;color:var(--tx3)'; td6.textContent = aDocNames.join(', ');
        const td7 = document.createElement('td'); td7.style.cssText = 'padding:10px 14px;font-size:11px;color:var(--tx3)'; td7.textContent = aDates.join(', ');
        tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5); tr.appendChild(td6); tr.appendChild(td7);
        tbody.appendChild(tr);

        // Detail rows (hidden, toggle on click)
        const detailRows = [];
        aEntries.forEach(e => {
          const d = parseFloat(e.debit || 0), c = parseFloat(e.credit || 0), ds = d - c;
          const doc = (e.source_file || '').replace(/FINANSIJSKO KNJIZENJE /g, '').replace(/_Privredno.*/, '');
          const dtr = document.createElement('tr'); dtr.style.cssText = 'display:none;background:rgba(201,168,76,.04);border-bottom:1px solid var(--border-lt)';
          const dt1 = document.createElement('td'); dt1.style.cssText = 'padding:8px 14px 8px 44px;font-size:12px;color:var(--tx3)'; dt1.textContent = '';
          const dt2 = document.createElement('td'); dt2.style.cssText = 'padding:8px 14px;font-size:12px;color:var(--tx2)'; dt2.textContent = a.name;
          const dt3 = document.createElement('td'); dt3.style.cssText = 'padding:8px 14px;text-align:right;font-family:var(--mn);font-size:12px';
          if (d > 0) { dt3.textContent = fNum(d); dt3.style.color = 'var(--dng)'; }
          const dt4 = document.createElement('td'); dt4.style.cssText = 'padding:8px 14px;text-align:right;font-family:var(--mn);font-size:12px';
          if (c > 0) { dt4.textContent = fNum(c); dt4.style.color = 'var(--suc)'; }
          const dt5 = document.createElement('td'); dt5.style.cssText = 'padding:8px 14px;text-align:right;font-family:var(--mn);font-size:12px;color:' + (ds >= 0 ? 'var(--dng)' : 'var(--suc)'); dt5.textContent = fNum(ds);
          const dt6 = document.createElement('td'); dt6.style.cssText = 'padding:8px 14px;font-size:11px;color:var(--tx3)'; dt6.textContent = doc;
          const dt7 = document.createElement('td'); dt7.style.cssText = 'padding:8px 14px;font-size:11px;color:var(--tx3)'; dt7.textContent = e.booking_date || '';
          dtr.appendChild(dt1); dtr.appendChild(dt2); dtr.appendChild(dt3); dtr.appendChild(dt4); dtr.appendChild(dt5); dtr.appendChild(dt6); dtr.appendChild(dt7);
          tbody.appendChild(dtr);
          detailRows.push(dtr);
        });

        tr.onclick = () => {
          const open = detailRows[0]?.style.display !== 'none';
          detailRows.forEach(r => r.style.display = open ? 'none' : '');
          chevA.style.transform = open ? '' : 'rotate(90deg)';
        };
      });
    }

    // Totals row
    const ttr = document.createElement('tr'); ttr.style.cssText = 'background:rgba(201,168,76,.15);border-top:2px solid var(--acc)';
    const tt1 = document.createElement('td'); tt1.colSpan = 2; tt1.style.cssText = 'padding:14px;font-size:14px;font-weight:700;color:var(--acc)'; tt1.textContent = 'UKUPNO ' + k.rs_code;
    const tt3 = document.createElement('td'); tt3.style.cssText = 'padding:14px;text-align:right;font-family:var(--mn);font-size:14px;font-weight:700;color:var(--dng)'; tt3.textContent = fNum(k.totalD);
    const tt4 = document.createElement('td'); tt4.style.cssText = 'padding:14px;text-align:right;font-family:var(--mn);font-size:14px;font-weight:700;color:var(--suc)'; tt4.textContent = fNum(k.totalC);
    const tt5 = document.createElement('td'); tt5.style.cssText = 'padding:14px;text-align:right;font-family:var(--mn);font-size:14px;font-weight:700;color:' + (saldo > 0 ? 'var(--dng)' : 'var(--suc)'); tt5.textContent = fNum(saldo);
    const tt6 = document.createElement('td'); tt6.style.cssText = 'padding:14px';
    const tt7 = document.createElement('td'); tt7.style.cssText = 'padding:14px';
    ttr.appendChild(tt1); ttr.appendChild(tt3); ttr.appendChild(tt4); ttr.appendChild(tt5); ttr.appendChild(tt6); ttr.appendChild(tt7);
    tbody.appendChild(ttr);

    tbl.appendChild(tbody); body.appendChild(tbl);
    card.appendChild(hdr); card.appendChild(body); out.appendChild(card);
  });
  // Poslednja klasa
  renderClassTotal(currentClass);
}

export function exportKontoXlsx() {
  if (!lastResults.length) return;
  const hS = { font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 }, fill: { fgColor: { rgb: '0F1923' } } };
  const nS = { font: { sz: 10 }, numFmt: '#,##0.000' };
  function c(v, s) { return { v, s, t: typeof v === 'number' ? 'n' : 's' }; }

  const rows = [];
  rows.push([c('ECOR SERBIA \u2014 Pregled konta: ' + [...selectedKonta].join(', '), { font: { bold: true, sz: 14 } }), c('', {}), c('', {}), c('', {}), c('', {}), c('', {}), c('', {}), c('', {})]);
  rows.push(['Konto', 'Naziv', 'Analitika', 'Duguje', 'Potražuje', 'Nivo', 'Izvod', 'Period'].map(h => c(h, hS)));
  lastResults.forEach(e => {
    const d = parseFloat(e.debit || 0), cr = parseFloat(e.credit || 0);
    const per = e.period_from ? new Date(e.period_from).toLocaleDateString('sr-RS') + '-' + new Date(e.period_to).toLocaleDateString('sr-RS') : '';
    rows.push([c(e.rs_code, {}), c(e.en_name || '', {}), c(e.analytic_name || '', {}), c(d || null, nS), c(cr || null, nS), c(e.detail_level, {}), c(e.izvod_number || '', {}), c(per, {})]);
  });

  const ws = XLSX.utils.aoa_to_sheet(rows.map(r => r.map(c => c.v)));
  ws['!cols'] = [{ wch: 10 }, { wch: 30 }, { wch: 25 }, { wch: 14 }, { wch: 14 }, { wch: 10 }, { wch: 20 }, { wch: 20 }];
  rows.forEach((row, ri) => { row.forEach((cell, ci) => { const addr = XLSX.utils.encode_cell({ r: ri, c: ci }); if (ws[addr]) ws[addr].s = cell.s; }); });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Pregled konta');
  const query = [...selectedKonta].join(', ');
  XLSX.writeFile(wb, 'konto_' + query + '.xlsx', { bookSST: false, cellStyles: true });
  toast('Excel eksportovan');
  if (state.CU) sb.rpc('log_audit', { p_user_id: state.CU.id, p_action: 'export_excel', p_entity_type: 'konto', p_entity_name: 'konto_' + query }).then(null, e => console.error('SBIS:', e));
}
